import {z} from 'zod';
import {ExportTypes} from '../../common/exportTypes';

const ACCEPTED_FILE_TYPES = ['nbl'];

export const importElementFileTypeSchema = z.object({
    file: z.any().refine((file) => {
        const fileExtension = file?.name.split('.').pop();
        return file && ACCEPTED_FILE_TYPES.includes(fileExtension);
    }, 'contextMenuSlide.errors.importElementWrongFileType'),
});

export const importElementFileContentSchema = z.object({
    type: z.nativeEnum(ExportTypes).refine((value) => value === ExportTypes.SLIDE_ELEMENT, {
        message: 'contextMenuSlide.errors.importElementWrongType',
    }),
});
